const loc = (lang: string) => (lang === 'en' ? 'en-EG' : 'ar-EG-u-nu-latn');

export const fmtDateTime = (s: string | Date | null | undefined, lang: string) =>
  s ? new Intl.DateTimeFormat(loc(lang), { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Africa/Cairo' }).format(new Date(s)) : '—';

export const fmtDate = (s: string | Date | null | undefined, lang: string) =>
  s ? new Intl.DateTimeFormat(loc(lang), { dateStyle: 'medium', timeZone: 'Africa/Cairo' }).format(new Date(s)) : '—';

export const fmtNumber = (n: number | string | null | undefined, lang: string, digits = 0) =>
  n === null || n === undefined || n === '' ? '—' : new Intl.NumberFormat(loc(lang), { maximumFractionDigits: digits }).format(Number(n));

export const fmtEgp = (n: number | string | null | undefined, lang: string) =>
  n === null || n === undefined || n === '' ? '—' : new Intl.NumberFormat(loc(lang), { style: 'currency', currency: 'EGP', maximumFractionDigits: 0 }).format(Number(n));

/** "منذ 3 د" / "3 min ago" style relative time. */
export function fmtAgo(s: string | Date | null | undefined, lang: string): string {
  if (!s) return '—';
  const diff = (Date.now() - new Date(s).getTime()) / 1000;
  const rtf = new Intl.RelativeTimeFormat(loc(lang), { numeric: 'auto' });
  if (diff < 60) return rtf.format(-Math.round(diff), 'second');
  if (diff < 3600) return rtf.format(-Math.round(diff / 60), 'minute');
  if (diff < 86400) return rtf.format(-Math.round(diff / 3600), 'hour');
  return rtf.format(-Math.round(diff / 86400), 'day');
}

/** Duration in seconds → "1 س 13 د" / "1h 13m". */
export function fmtDuration(sec: number | null | undefined, lang: string): string {
  if (sec === null || sec === undefined) return '—';
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = Math.floor(sec % 60);
  const parts: string[] = [];
  if (h) parts.push(lang === 'en' ? `${h}h` : `${h} س`);
  if (m || h) parts.push(lang === 'en' ? `${m}m` : `${m} د`);
  if (!h) parts.push(lang === 'en' ? `${s}s` : `${s} ث`);
  return parts.join(' ');
}

/** ISO date (YYYY-MM-DD) from a Date or ISO string, in Cairo time. */
export const toIsoDate = (s: string | Date | null | undefined) => (s ? new Date(s).toISOString().slice(0, 10) : '');
